function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import useRelativeDate from '@paperstac/common/lib/hooks/useRelativeDate';
import { normalizeDate } from '@paperstac/helpers/lib/dateHelpers';
import format from 'date-fns/format';
import PropTypes from 'prop-types';
import React from 'react';
import Text from './Text';
import Tooltip from './Tooltip';
export const RelativeDate = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    date,
    ...props
  } = _ref;
  const relative = useRelativeDate(date);
  const formatted = React.useMemo(() => !!date ? format(normalizeDate(date), 'MMM d, yyyy, h:mma') : '', [date]);
  if (!date) return null;
  return /*#__PURE__*/React.createElement(Text, _extends({
    ref: ref,
    __css: {
      display: 'inline',
      borderBottom: 'dotted'
    }
  }, props), /*#__PURE__*/React.createElement(Tooltip, {
    tooltip: formatted
  }, " ", relative));
});
RelativeDate.propTypes = {
  date: PropTypes.object.isRequired
};
RelativeDate.defaultProps = {};
RelativeDate.displayName = 'RelativeDate';
export default RelativeDate;